
export enum LocationType {
    Origin,
    Destination
}

export enum StagingType {
    Contracts,
    Defaults
}

export enum ListType {
    Account,
    Commodity,
    Loc,
    UnitOfMeasure
}

export enum FormStatus {
    Normal,
    Delete,
    ConfirmSave,
    Saving,
    Deleting
}

export enum LoadBankType {
    Load,
    Unload
}

export enum UserRoleEnum {
    MA = 'MA',
    Trader = 'Trader',
    Manager = 'Manager',
    IT = 'IT',
    ScaleOperator = 'ScaleOperator',
}

export enum UserRoleIdEnum {
    MA = '1',
    Trader = '2',
    Manager = '3',
    IT = '4',
    ScaleOperator = '5',
}